export const EXSBBATCHNUMBER_SHOW_RESET = 'EXSBBATCHNUMBER_SHOW_RESET'
export const EXSBBATCHNUMBER_SHOW_SET_ERROR = 'EXSBBATCHNUMBER_SHOW_SET_ERROR'
export const EXSBBATCHNUMBER_SHOW_SET_RETRIEVED = 'EXSBBATCHNUMBER_SHOW_SET_RETRIEVED'
export const EXSBBATCHNUMBER_SHOW_TOGGLE_LOADING = 'EXSBBATCHNUMBER_SHOW_TOGGLE_LOADING'
